import React, { useState } from 'react';
import { BOOKING_HREF, handleBookingClick } from '../../utils/bookingNavigation';
import './Services.css';
import servicesWave from '../../assets/waves/Shape 3.svg';
import imgLandscapeService from '../../assets/services/card-landscape-design.png';
import imgYardService from '../../assets/services/card-yard-care.jpg';

const services = [
  {
    number: '01', eyebrow: 'Custom Installation', title: 'Landscape Design & Installation',
    pageHref: '/services/landscape-design',
    description: 'From a single conversation to a completely transformed yard. We design, source, and build custom landscapes tailored to Colorado living in the Roaring Fork Valley — working with your space, your style, and your budget from the very first sketch to the final walkthrough.',
    tags: ['Flagstone & Pavers', 'Xeriscape', 'Retaining Walls', 'Drip Irrigation', 'Native Plants', 'Artificial Turf'],
    servicesLabel: 'Our services:',
    servicesList: [
      ['Sod installation & removal', 'Retaining wall installation'],
      ['Fabric installation', 'Fence installation'],
      ['Plant selection & installation', 'Flagstone installation'],
      ['Xeriscape prep, installation, edging & pathways', 'Artificial turf installation'],
      ['Boulder selection & installation', 'Paver installation'],
      ['Drip irrigation installation', 'Concrete work'],
    ],
    ctaText: 'Get a Landscape Design & Installation Quote →',
    image: imgYardService, imageAlt: 'Yard maintenance Glenwood Springs Colorado', imagePosition: 'center bottom', numberOpacity: '0.12',
  },
  {
    number: '02', eyebrow: 'Ongoing Maintenance', title: 'Complete Yard Care',
    pageHref: '/services/complete-yard-care',
    description: "Your yard stays beautiful through every season without you lifting a finger. We handle everything — spring startup, summer upkeep, fall cleanup, and full winterization. Reliable, thorough, always on schedule. Designed for Colorado's seasons — spring snowmelt to dry summer heat to fall prep.",
    tags: ['Mowing & Edging', 'Irrigation', 'Aeration & Dethatching', 'Fertilization', 'Tree & Shrub Trimming', 'Gutter Cleaning'],
    servicesLabel: 'Our services:',
    servicesList: [
      ['Spring & fall cleanup (8 hrs)', 'Fertilization'],
      ['Irrigation start-up, maintenance & winterization', 'Weed control & weed whacking'],
      ['Dethatching', 'Tree trimming'],
      ['Aeration', 'Shrub trimming'],
      ['Mowing', 'Gutter cleaning'],
      ['Trimming & edging', ''],
    ],
    ctaText: 'Get a Yard Care Quote →',
    image: imgLandscapeService, imageAlt: 'Landscape design and installation Aspen Colorado', numberOpacity: '0.5',
  },
];

const Services = () => {
  const [tappedIndex, setTappedIndex] = useState(null);
  const handleCardClick = (i) => setTappedIndex(tappedIndex === i ? null : i);

  return (
    <section className="services" id="services">
      <div className="services__inner">
        <div className="services__header">
          <span className="services__tag">What We Do</span>
          <h2 className="services__heading">Everything your yard <span className="services__heading-accent">deserves</span></h2>
        </div>
        <div className="services__cards">
          {services.map((service, i) => (
            <div key={service.number} className={`service-card ${tappedIndex === i ? 'service-card--tapped' : ''}`} onClick={() => handleCardClick(i)}>
              <img src={service.image} alt={service.imageAlt} className="service-card__bg" style={service.imagePosition ? { objectPosition: service.imagePosition } : undefined} />
              <div className="service-card__default">
                <div className="service-card__overlay" />
                <span className="service-card__number" style={{ opacity: service.numberOpacity }}>{service.number}</span>
                <div className="service-card__default-content">
                  <p className="service-card__eyebrow">{service.eyebrow}</p>
                  <h3 className="service-card__title">
                    {service.pageHref ? (
                      <a
                        href={service.pageHref}
                        className="service-card__title-link"
                        onClick={e => e.stopPropagation()}
                      >
                        {service.title}
                      </a>
                    ) : (
                      service.title
                    )}
                  </h3>
                  <p className="service-card__desc">{service.description}</p>
                  <div className="service-card__tags">
                    {service.tags.map(tag => <span key={tag} className="service-card__tag service-card__tag--dark">{tag}</span>)}
                  </div>
                </div>
              </div>
              <div className="service-card__hover">
                <p className="service-card__hover-eyebrow">{service.eyebrow}</p>
                <h3 className="service-card__hover-title">
                  {service.pageHref ? (
                    <a
                      href={service.pageHref}
                      className="service-card__title-link service-card__title-link--hover"
                      onClick={e => e.stopPropagation()}
                    >
                      {service.title}
                    </a>
                  ) : (
                    service.title
                  )}
                </h3>
                <p className="service-card__hover-desc">{service.description}</p>
                <div className="service-card__tags">
                  {service.tags.map(tag => <span key={tag} className="service-card__tag service-card__tag--light">{tag}</span>)}
                </div>
                <p className="service-card__hover-services-label">{service.servicesLabel}</p>
                <div className="service-card__hover-list">
                  {service.servicesList.map((row, j) => (
                    <div key={j} className="service-card__hover-row">
                      {row[0] && <div className="service-card__hover-item"><span className="service-card__bullet" /><span>{row[0]}</span></div>}
                      {row[1] && <div className="service-card__hover-item"><span className="service-card__bullet" /><span>{row[1]}</span></div>}
                    </div>
                  ))}
                </div>
                <div className="service-card__hover-cta-wrap">
                  <a
                    href={BOOKING_HREF}
                    className="service-card__hover-cta"
                    onClick={e => {
                      e.stopPropagation();
                      handleBookingClick(e);
                    }}
                  >
                    {service.ctaText}
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <img src={servicesWave} alt="" className="services__wave" />
    </section>
  );
};

export default Services;
